/**
 * Awvent - Subscriptions API
 * Awvent Subscriptions Apis
 *
 * OpenAPI spec version: v1
 * Contact: info@prestine.in
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { VerificationStatus } from "../../enums/public-api";

export class PhoneNumberDto {
    countryCode?: string;
    dialCode?: string;
    extensionNumber?: string;
    label?: string;
    value?: string;
    verificationStatus?: VerificationStatus;
}
